// removed by extract-text-webpack-plugin
module.exports = {"btn":"src-components-button-arrow----button-arrow-module---btn---3nwWH","btnText":"src-components-button-arrow----button-arrow-module---btnText---2a2X9","btnBG":"src-components-button-arrow----button-arrow-module---btnBG---2hkt2","btnTransparent":"src-components-button-arrow----button-arrow-module---btnTransparent---1Q0Fq","explore":"src-components-button-arrow----button-arrow-module---explore---1uPO6","exploreArrow":"src-components-button-arrow----button-arrow-module---exploreArrow---3RNCe","icon":"src-components-button-arrow----button-arrow-module---icon---2t6sd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/button-arrow/button-arrow.module.css
// module id = 161
// module chunks = 35783957827783 140935043865547